import { truncStr, TruncStrOpts } from 'utils'
import React from 'react'
import styled, { css } from 'styled-components'

export const truncStyles = css``

const TruncView = styled.span`
	${truncStyles}
`

export type TruncProps = TruncStrOpts & {
	children?: string
	noHtml?: boolean // Returns string without markup
}
export const Trunc = ({ children, noHtml, ...truncOpts }: TruncProps) => {
	const truncedStr = truncStr(children, truncOpts)

	return noHtml ? <>{truncedStr}</> : <TruncView className='trunced'>{truncedStr}</TruncView>
}
